import styled from 'styled-components';

const SelectWrapper = styled.div`
  width: 80px;
  position: absolute;
  top: -2px;
  right: 40px;
`

export { SelectWrapper }